import { createConnection } from '@widget-kit/rpc';
export { createRequest } from '@widget-kit/rpc';

function resolveOrigin(window, url) {
    var matches = url.match(/^(https?:)?\/\/[.\w]+(:\d+)?/i);
    if (!matches) {
        throw new Error('Invalid url');
    }
    return matches[0].replace(/^\/\//, window.location.protocol + "//");
}

function createContainer(widgetUrl, config) {
    if (config === void 0) { config = {}; }
    var document = window.document;
    var parentElement = config.parentElement || document.body;
    var iframe = document.createElement('iframe');
    iframe.src = widgetUrl;
    iframe.frameBorder = '0';
    iframe.scrolling = 'no';
    parentElement.appendChild(iframe);
    var widgetWindow = iframe.contentWindow;
    var widgetOrigin = resolveOrigin(window, widgetUrl);
    var _a = createConnection(widgetWindow, widgetOrigin), send = _a.send, handle = _a.handle;
    return { send: send, handle: handle, iframe: iframe };
}

function initWidget(containerOrigin) {
    if (containerOrigin === void 0) { containerOrigin = '*'; }
    var containerWindow = window.parent;
    if (containerWindow === window) {
        throw new Error('No parent window, widget must be loaded in an iframe');
    }
    return createConnection(containerWindow, containerOrigin);
}

export { createContainer, initWidget };
//# sourceMappingURL=index.esm.js.map
